var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFavIconBlack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6799 16.9596L18.5499 9.64964C17.4899 7.16964 15.5399 7.06964 14.2299 9.42964L12.3399 12.8396C11.3799 14.5696 9.58993 14.7196 8.34993 13.1696L8.12993 12.8896C6.83993 11.2696 5.01993 11.4696 4.08993 13.3196L2.36993 16.7696C1.15993 19.1696 2.90993 21.9996 5.58993 21.9996H18.3499C20.9499 21.9996 22.6999 19.3496 21.6799 16.9596Z",
    stroke: "#1E1C1C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.97021 8C8.62707 8 9.97021 6.65685 9.97021 5C9.97021 3.34315 8.62707 2 6.97021 2C5.31336 2 3.97021 3.34315 3.97021 5C3.97021 6.65685 5.31336 8 6.97021 8Z",
    stroke: "#1E1C1C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavIconBlack);
export default __webpack_public_path__ + "static/media/favIcon-black.062fb4fa58c567934168b19d5df528fc.svg";
export { ForwardRef as ReactComponent };